// matches with or without protocol/www since users often paste links without "https://"
const YOUTUBE_SHORTS_REGEX = /^(?:https?:\/\/)?(?:www\.|m\.)?(?:youtube\.com|youtu\.be)\/shorts\//i

function isYoutubeShortsUrl (videoUrl) {
  if (!videoUrl) { return false }

  return YOUTUBE_SHORTS_REGEX.test(videoUrl.trim())
}

function videoGreetingValidation (videoUrl) {
  return !isYoutubeShortsUrl(videoUrl) || 'YouTube Shorts videos are not supported for video greetings'
}

export { isYoutubeShortsUrl, videoGreetingValidation }
export default videoGreetingValidation
